import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLanguage } from '../context/LanguageContext';
import './RouvyDomainHint.css';

// ROUVY возвращает часть пользователей на домен .ru, откуда redirect в приложение
// не срабатывает. Текст предупреждения плюс короткое видео, где показано, как
// поправить адрес вручную. Используется везде, откуда уходим на Authorize:
// секция ROUVY в профиле, плашка переподключения и модалка после входа.
const RouvyDomainHint = ({ className = '' }) => {
  const { t } = useLanguage();
  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    if (!videoOpen) return undefined;

    const handleKey = (e) => {
      if (e.key === 'Escape') setVideoOpen(false);
    };

    window.addEventListener('keydown', handleKey);

    return () => window.removeEventListener('keydown', handleKey);
  }, [videoOpen]);

  return (
    <div className={`rouvy-domain-hint ${className}`.trim()}>
      <p className="rouvy-domain-hint-text">{t('rouvy.domainHint')}</p>

      <button
        type="button"
        className="rouvy-domain-hint-toggle"
        onClick={() => setVideoOpen(true)}
      >
        {t('rouvy.domainHintVideoShow')}
      </button>

      {/* Портал в body: подсказка живет и внутри модалки переподключения,
          откуда обычный оверлей оказался бы под ее фоном */}
      {videoOpen && ReactDOM.createPortal(
        <div
          className="rouvy-domain-video-overlay"
          onClick={() => setVideoOpen(false)}
        >
          <div
            className="rouvy-domain-video-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="rouvy-domain-video-close"
              onClick={() => setVideoOpen(false)}
              aria-label={t('common.close')}
            >
              ×
            </button>

            {/* autoPlay без звука: ролик короткий и открывается по явному клику */}
            <video
              className="rouvy-domain-video"
              src="/rouvy-auth-hint.mp4"
              poster="/rouvy-auth-hint.jpg"
              controls
              autoPlay
              playsInline
            />
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default RouvyDomainHint;
